import { maxBy } from "lodash";
import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const users = (state = initialState.users, action) => {
  switch (action.type) {
    case types.LOAD_USER_SUCCESS:
      return action.users;

    case types.CREATE_USER_SUCCESS:
      return [...state, { ...action.user }];

    case types.UPDATE_USER_SUCCESS:
      return [
        ...state.filter((u) => u._id !== action.user._id),
        { ...action.user }
      ];

    case types.DELETE_USER_SUCCESS:
      return [...state.filter((u) => u._id !== action.userId)];

    default:
      return state;
  }
};

export const allUsers = (state = initialState.allUsers, action) => {
  switch (action.type) {
    case types.LOAD_ALL_USERS_SUCCESS:
      return action.allUsers;
    case types.DELETE_ALL_USERS_SUCCESS:
      return [...state.filter((u) => u._id !== action.userId)];
    default:
      return state;
  }
};
export const user = (state = initialState.user, action) => {
  switch (action.type) {
    case types.GET_USER_SUCCESS:
      return action.user;

    default:
      return state;
  }
};

export const savingUser = (state = initialState.savingUser, action) => {
  switch (action.type) {
    case types.SAVING_USER:
      return action.savingUser;

    default:
      return state;
  }
};

export const userToDelete = (state = initialState.userToDelete, action) => {
  switch (action.type) {
    case types.REQUEST_USER_ID:
      return action.userToDelete;

    default:
      return state;
  }
};

export const auth = (state = initialState.auth, action) => {
  switch (action.type) {
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        username: action.user.user.email,
        isAuth: true,
        roles: action.user.user.roles,
        isNightMode: action.user.user.is_night_mode,
        maxRole: maxBy(action.user.user.roles, "number")?.number,
        isAdmin: maxBy(action.user.user.roles, "number")?.number === 9000,
        user: action.user.user,
        isLoading: false,
        refreshTokenExpires: action.user.tokens.refresh.expires
      };

    case types.AUTH_REFRESH_FAILURE:
    case types.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        username: "",
        isAuth: false,
        isNightMode: false,
        maxRole: false,
        isAdmin: false,
        roles: false,
        user: {},
        isLoading: false
      };

    case types.AUTH_REFRESH_SUCCESS:
      return {
        ...state,
        username: action.data.user.email,
        isAuth: true,
        roles: action.data.user.roles,
        isNightMode: action.data.user.is_night_mode,
        maxRole: maxBy(action.data.user.roles, "number")?.number,
        isAdmin: maxBy(action.data.user.roles, "number")?.number === 9000,
        user: action.data.user,
        isLoading: false,
        refreshTokenExpires: action.data.tokens.refresh.expires
      };

    case types.UPDATE_FAVORITES_SUCCESS:
      return {
        ...state,
        user: { ...state.user, favorites: action.user.favorites }
      };

    case types.UPDATE_THEME_SUCCESS:
      return {
        ...state,
        isNightMode: action.user.is_night_mode,
        user: action.user
      };

    case types.RESET_PASS_SENT_SUCCESS:
      return { ...state, resetSent: true, isLoading: false };

    case types.RESET_PASS_SUCCESS:
      return { ...state, resetSent: false, isLoading: false };

    default:
      return state;
  }
};

export const resource_summary = (
  state = initialState.resource_summary,
  action
) => {
  switch (action.type) {
    case types.USER_RESOURCE_SUMMARY_SUCCESS:
      return action.resource_summary;

    default:
      return state;
  }
};
